import { IconButton, IconSettingsLine } from "@instructure/ui";
import { t } from "i18next";
import { useState } from "react";
import SettingsModal from "./SettingsModal";

const SettingsCell = ({ row, departments, setRows, getRole }) => {
  const [open, setOpen] = useState(false);

  return (
    <div style={{ textAlign: "center" }}>
      <IconButton
        onClick={() => setOpen(true)}
        screenReaderLabel={t("user.manageUserSettings", { name: row.fullName })}
        renderIcon={IconSettingsLine}
      />
      <SettingsModal
        open={open}
        setOpen={setOpen}
        userInfo={row}
        departments={departments}
        setRows={setRows}
        getRole={getRole}
      />
    </div>
  );
};

export default SettingsCell;
